// NPM Imports
import moment from "moment";

export default (
  state = {
    data: {},
    doc_name: "",
    doc_owner: "",
    doc_stage: "",
    is_lz: false,
    is_integration: false,
    redirect_url: "",
    isAgreed: false,
    isSigned: false,
    scrollToInfo: { list: [], activeIndex: 0 },
    signatories: {},
    toSignInfo: { total: 0, signed: 0 },
    user: {},
    drawSignImageUrl: "",
    drawSignFont: "",
    drawSignType: "",
    showDrawSignPopup: false,
    drawSignBlockID: null,
    drawSignPopupMode: "",
    link_expiry_time: null,
    signText: "",
    metamaskData: {},
    tagValues: {},
  },
  action,
) => {
  switch (action.type) {
    case "FETCH_DOC_FOR_ESIGNING":
      return {
        ...state,
        doc_name: action.payload.data.doc_name,
        doc_owner: action.payload.data.doc_owner,
        doc_stage: action.payload.data.doc_stage,
        is_lz: action.payload.data.is_lz,
        is_integration_org: action.payload.data.is_integration_org,
        is_ep_document: action.payload.data.is_ep_document,
        redirect_url: action.payload.data.redirect_url,
        doc_object_id: action.payload.data.doc_object_id,
        isSigned: action.payload.data.isSigned,
        signatories: action.payload.data.signatories,
        user: action.payload.data.user,
        link_expiry_time: action.payload.data.link_expiry_time,
      };
    case "UPDATE_DOC_SIGNER_INFO":
      return {
        ...state,
        data: action.payload.tagBlocks,
        toSignInfo: {
          ...state.toSignInfo,
          total: action.payload.activeUserScrollAnchorTags.length,
        },
        scrollToInfo: {
          ...state.scrollToInfo,
          list: action.payload.activeUserScrollAnchorTags,
        },
      };
    case "FETCH_DOC_AFTER_ESIGNING":
      return {
        ...state,
        doc_name: action.payload.data.doc_name,
        doc_owner: action.payload.data.doc_owner,
        doc_stage: action.payload.data.doc_stage,
        isSigned: action.payload.data.isSigned,
        signatories: action.payload.data.signatories,
        isAgreed: false,
      };
    case "ON_AGREEMENT_TERM_ACCEPT":
      return {
        ...state,
        isAgreed: true,
      };
    case "ON_SIGN_TAG_CLICK":
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload]: {
            ...state.data[action.payload],
            isClicked: true,
            timestamp: moment().format(),
            isLastPosition:
              state.toSignInfo.signed === state.toSignInfo.total - 1,
          },
        },
        toSignInfo: {
          ...state.toSignInfo,
          signed: state.toSignInfo.signed + 1,
        },
        scrollToInfo: {
          ...state.scrollToInfo,
          activeIndex: state.data[action.payload].position,
        },
      };
    case "SEND_FOR_ESIGN":
      return {
        ...state,
        doc_stage: action.payload.doc_stage,
        isAgreed: false,
      };
    case "UPDATE_SIGN_TAG_VALUE": {
      const { tagValues } = state;
      const updatedTagValues = {
        ...tagValues,
        [action.payload.id]: {
          ...tagValues[action.payload.id],
          tag_value: action.payload.value,
        },
      };
      return {
        ...state,
        tagValues: { ...updatedTagValues },
      };
    }
    case "UPDATE_SIGN_TAG_VALUES":
      return {
        ...state,
        tagValues: action.payload.tagValues,
      };
    case "SET_ACTIVE_SIGNERTAG_INDEX":
      return {
        ...state,
        scrollToInfo: {
          ...state.scrollToInfo,
          activeIndex: action.payload,
        },
      };

    case "SET_DRAWSIGN_DATA":
      return {
        ...state,
        drawSignImageUrl: action.payload.url,
        drawSignFont: action.payload.font,
        drawSignType: action.payload.type,
        signText: action.payload.signText,
        metamaskData: action.payload.metamaskData,
      };
    case "RESET_DRAWSIGN_DATA":
      return {
        ...state,
        drawSignImageUrl: "",
        drawSignFont: "",
        drawSignType: "",
        data: action.payload,
        toSignInfo: {
          ...state.toSignInfo,
          signed: 0,
        },
        scrollToInfo: { ...state.scrollToInfo, activeIndex: 0 },
      };
    case "DRAWSIGN_POPUP_TOGGLE":
      return {
        ...state,
        showDrawSignPopup: action.payload.toggle,
        drawSignBlockID: action.payload.id,
        drawSignPopupMode: action.payload.mode,
      };
    default:
      return state;
  }
};
